const gameUiTexts = {
	subtitle: {
		da:'Spillet om virksomhedsøkonomi',
		kl:'Suliffeqarfimmi aningaasaqarneq pillugu pinnguaat',
	},
	start: {
		da: 'Start',
		kl: 'Aallartigit',
	},
	manual: {
		da:'Lærervejledning',
		kl: 'Ilinniartitsisumut ilitsersuut',
	},
	viewVideo: {
		da: 'Se video',
		kl: 'Video takuuk',
	},
	loadingGame: {
		da: 'Henter spil ...',
		kl: 'Pinnguaat aaneqarpoq ...',
	},
	reset: {
		da: 'Reset',
		kl: 'Aallarteqqiguk',
	},
	budget: {
		da: 'Budget',
		kl: 'Missingersuut',
	},
	budgeted: {
		da:'Budgetteret',
		kl: 'Naatsorsuusiarineqarsimasut',
	},
	budgetThisQuarter: {
		da: 'Budget - dette kvartal',
		kl: 'Missingersuutit - ukiup sisamararterutaani uani',
	},
	actualBudget: {
		da: 'Realiseret',
		kl: 'Tunisat',
	},
	turnover: {
		da: 'Omsætning',
		kl: 'Kaaviiaartitat',
	},
	expenses: {
		da: 'Udgifter',
		kl: 'Aningaasartuutit',
	},
	profit: {
		da: 'Overskud',
		kl: 'Sinneqartoorutit',
	},
	quarter: {
		da: 'Kvartal',
		// Leaving out this translation, because it's too long to fit in
		// the UI, and isn't all that necessary.
		// kl: 'Kvartali - ukiup sisamararterutaa',
		kl: '',
	},
	kr: {
		da: 'kr',
		kl: 'kr',
	},
	ok: {
		da: 'OK',
		kl: 'OK',
	},
	go: {
		da: 'Go!',
		kl: 'Go!',
	},
	startNewGame: {
		da: 'Nyt spil',
		kl: 'Pinnguaat nutaaq aallartiguk',
	},
	currentSupplier: {
		da: 'Nuværende leverandør',
		kl: 'Maannakkut pilersuisuusoq',
	},

	betweenRoundsText: {
		da: 'I laver og sælger T-shirts på livet løs.',
		kl: 'Tujuuluaralioriarlusi tuniniaarsuaarniaritsi.',
	},

	optionCannotBeSelectedFeedback: {
		minBudgetStat: {
			turnover: {
				da: `Jeres omsætning for sidste kvartal var kun %value% kr.
				<br /><br />I skal have en omsætning på %required% kr for at få dette lån.`,
				kl: `Kvartali kingulleq kaaviiaartitasi taamaallaat naleqarput %value% kr.
				<br /><br />Taarsigassarsiniarussi kaaviiaartitasi %required% kr.-usariaqarput`,
			}
		}
	},

	maxOptionsSelected: {
		da: 'Du kan ikke vælge flere handlinger.<br /><br />Vælg en anden handling fra, hvis du gerne vil vælge denne handling.',
		kl: 'Allamik toqqagaqarsinnaanngilatit. Una toqqarusukkukku, toqqarsimasat alla piissavat.',
	},
	notEnoughtActionsSelected: {
		da: `Du har kun valgt %selectedActions% af %availableActions% mulige handlinger.
		<br /><br />Er du sikker på, du vil fortsætte?`,
		kl: `%selectedActions% kisiat toqqarsimavat periarfissani ukunani %availableActions%
		<br /><br />Ilumut ingerlaqqikkusuppit?`,
	},
	yesContinue: {
		da: 'Ja, fortsæt',
		kl: 'Aap, ingerlaqqissaanga',
	},
	noCancel: {
		da: 'Nej, afbryd',
		kl: 'Naamik, ingerlaqqissanngilanga',
	},
	cookieText1: {
		da: `Vi vil gerne gemme dine valgte handlinger og din progression i spillet i en cookie.
		<br /><br />Du kan ikke spille uden denne cookie. Tryk "JA" for at acceptere den.`,
		kl: `Toqqarsimasatit pinnguaammilu sumut killinnerit cookiemut toqqorusuppagut.
		<br /><br />Cookieqanngippat spil-ersinnaanngilatit. Akueriniarukku "AAP" tooruk.`,
	},
	cookieText2: {
		da: `<br />Cookien bliver gemt i et år.
		<br /><br />Trykke "NEJ" for at slette cookien og trække dit samtykke tilbage.`,
		kl: `<br />Cookie ukioq ataaseq toqqoqqasarpoq.
		<br /><br />Cookie peerniarukku "NAAMIK" tooruk, akuersisimanerit atorunnaarsillugu.`,
	},
	cookieSeeMore: {
		da: 'Se mere',
		kl: 'Takusassat ilakkit',
	},
	cookieSeeLess: {
		da: 'Se mindre',
		kl: 'Takusassat ikilisikkit',
	},
	yes: {
		da: 'Ja',
		kl: 'Aap',
	},
	no: {
		da: 'Nej',
		kl: 'Naamik',
	}
};
const statsUiTexts = {
	loginTitle: {
		da: 'Statistik',
		kl: 'Kisitsisinngorlugit takussutissaq',
	},
	email: {
		da: 'e-mail',
		kl: 'e-mail',
	},
	password: {
		da: 'password',
		kl: 'isertaat',
	},
	login: {
		da: 'Log ind',
		kl: 'Iserit',
	},
	logout: {
		da: 'Log ud',
		kl: 'Anigit',
	},
	unknownFejl: {
		da: 'Fejl: ukendt fejl',
		kl: 'Kukkuneq: sunaanera nalunarpoq',
	},
	someFieldsMissing: {
		da: 'Fejl: Husk at udfylde alle felter',
		kl: 'Kukkuneq: Immersuivissat tamakkissapput',
	},
	invalidEmail: {
		da: 'Fejl: Ugyldig e-mail',
		kl: 'Kukkuneq: e-mail atunngilaq',
	},
	invalidPassword: {
		da: 'Fejl: Forkert password',
		kl: 'Kukkuneq: isertaat kukkuvoq',
	},
	userNotFound: {
		da: 'Fejl: Ukendt bruger',
		kl: 'Kukkuneq: Atuisoq naluarput',
	},
	statsTitle: {
		da: 'Statistik for Iværksætterøkonomispil',
		kl: 'Aallarnisaasutut aningaasarsiortarneq pillugu pinnguaammi kisitsisitigut takussutissat',
	},
	gamesStarted: {
		da: 'Antal spil startet',
		kl: 'Pinnguaaternerit aallartissimasat katillugit',
	},
	gamesFinished: {
		da: 'Antal spil afsluttet',
		kl: 'Pinnguaaternerit naasimasat katillugit',
	},
	gamesOngoing: {
		da: 'Antal spil igangværende',
		kl: 'Pinnguaaternerit massakkut ingerlasut amerlassusaat',
	},
	players: {
		da: 'Spillere',
		kl: 'Pinnguaatertut',
	},
	playerId: {
		da: 'Id',
		kl: 'Atuisoq',
	},
	playDate: {
		da: 'Dato',
		kl: 'Ulloq',
	},
	lastRound: {
		da: 'Runder spillet',
		kl: 'Pinnguaammi naggasiisoq',
	},
	numberedActions: {
		action1: {
			da: 'Handling 1',
			kl: 'Toqqagassaq 1'
		},
		action2: {
			da: 'Handling 2',
			kl: 'Toqqagassaq 2'
		},
		action3: {
			da: 'Handling 3',
			kl: 'Toqqagassaq 3'
		},
		action4: {
			da: 'Handling 4',
			kl: 'Toqqagassaq 4'
		},
	},
	salesPrice: {
		da: 'Salgspris',
		kl: 'Tuninerani akia',
	},
	stock: {
		da: 'Lager',
		kl: 'Toqqorsivik',
	},
	purchase: {
		da: 'Indkøb',
		kl: 'Pisiat',
	},
	prodCap: {
		da: 'Prod.-kapacitet',
		kl: 'Nioqqutissiat amerlassuserisinnaasaat',
	},
	buyingCustomers: {
		da: 'Kunder der køber',
		kl: 'Pisisartut',
	},
	turnover: {
		da: 'Omsætning',
		kl: 'Kaaviiaartitat',
	},
	expenses: {
		da: 'Udgifter',
		kl: 'Aningaasartuutit',
	},
	profit: {
		da: 'Overskud',
		kl: 'Sinneqartoorutit',
	},
	liquidity: {
		da: 'Likviditet',
		kl: 'Akiliisinnaassuseqarneq',
	},
	download: {
		da: 'Download data',
		kl: 'Aallerit',
	}

};

module.exports = {
	gameUiTexts,
	statsUiTexts
};